import { CandidateSchema } from '@axiom/validation';
import type { z } from 'zod';

export const PerformanceFeedbackFormSchema = CandidateSchema.pick({
  showReputation: true,
});

export type PerformanceFeedbackForm = z.infer<
  typeof PerformanceFeedbackFormSchema
>;
